<template>
	<base-layout :withHeaderStructure='true'>
		<template v-slot:header>
			<div class="mt-5 mb-3 md:flex md:items-center md:justify-between">
				<div class="flex-1 min-w-0">
					<template v-if="isSeoLanding">
						<h1 class="text-2xl font-bold leading-7 text-gray-900 sm:text-2xl sm:text-3xl leading-9">
							{{ $route.meta.h1 }}
						</h1>
						<p class="mt-3 text-base text-gray-700 leading-relaxed max-w-4xl">
							{{ $route.meta.intro }}
						</p>
					</template>
					<h2 v-else class="text-2xl font-bold leading-7 text-gray-900 sm:text-2xl sm:text-3xl leading-9 sm:truncate">
					Broadcasts
					</h2>
				</div>

				<div class="relative self-end md:self-auto text-left">
					<div v-if='user && user.isServiceOnly===0' class="mt-4 flex md:mt-0 md:ml-4" >
						<button type="button" class="btn btn-primary" @click="showComposeBroadcast">Compose</button>
						<button type="button" class="ml-3 pr-3 text-sm btn btn-muted text-red-700 border-red-700 hover:text-red-700" @click="$refs.broadcastList.showMainDropdown = !$refs.broadcastList.showMainDropdown">
							More
							<svg class="-mr-1 ml-2 h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
								<path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
							</svg>
						</button>
					</div>

					<div v-if='isLoaded'>
						<div v-if='$refs.broadcastList.showMainDropdown' v-on-clickaway="$refs.broadcastList.closeMainDropdown" class="origin-top-right absolute right-0 mt-2 w-64 rounded-md shadow-lg z-50 bg-red-400">
						<div class="rounded-md bg-white shadow-xs">
					      <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
					      	<a href="javascript:void(0)" @click="showBroadcastSettings" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Broadcast Settings</a>
					        <a href="javascript:void(0)" @click="$refs.broadcastList.showBroadcastRulesModal = true; $refs.broadcastList.showMainDropdown = false" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Broadcast Rules</a>
					        <a href="javascript:void(0)" @click="$refs.broadcastList.showGradingGuidelinesModal = true; $refs.broadcastList.showMainDropdown = false" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">Grading Guidelines</a>
							<hr>
							<a href="/help/how-to-create-a-broadcast" target="_blank" rel="noopener noreferrer" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">How to Send Broadcasts</a>
							<a href="/help/how-to-save-broadcast-search" target="_blank" rel="noopener noreferrer" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">How to Save Broadcast Search</a>
							<a href="/help/how-to-manage-broadcast-emails" target="_blank" rel="noopener noreferrer" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">How to Manage Broadcast Emails</a>
						  </div>
					    </div>
					  </div>
					</div>
				</div>

				<ModalPossibleMatches></ModalPossibleMatches>
				
			</div>
		</template>
		<template v-slot:main>
			<BroadcastList ref='broadcastList' ></BroadcastList>
		</template>
	</base-layout>
</template>
 
<script>

import { mapState, mapActions, mapGetters } from 'vuex';
import BaseLayout from '@/components/BaseLayout.vue'
import BroadcastList from '@/components/BroadcastList.vue'
import possibleMatchMixin from '@/components/mixins/possibleMatchMixin.js'
import ModalPossibleMatches from '@/components/ModalPossibleMatches.vue'
import { mixin as clickaway } from 'vue-clickaway';


export default {
	name: 'Broadcasts',
	mixins: [possibleMatchMixin, clickaway],
	components: {
    BaseLayout,
    BroadcastList,
		ModalPossibleMatches,
  },
  data: () => ({
  	isLoaded: false,
  }),
  /** Opens an explicitly linked source; the matching mixin owns send-event subscriptions. @returns {Promise<void>} */
  async mounted() {
    // Mark the screen ready and restore an optional direct Possible Matches link.
    this.isLoaded = true;
    if (this.$route.query.possibleMatchId) await this.loadPossibleMatches(this.$route.query.possibleMatchId);
  },
  computed: {
	...mapState(['user', 'broadcasts']),
	...mapGetters(['broadcastsEnrichedFN', 'broadcastsEnriched']),
	isSeoLanding() {
		return !this.user && !!this.$route.meta?.seoLanding;
	},
  },
  methods: {
  	showBroadcastSettings(){
  		this.$refs.broadcastList.showBroadcastSettings();
  	},
  	showComposeBroadcast(){
  		this.$refs.broadcastList.showComposeBroadcast();
  	},
  },
}
</script>
